export default "__VITE_ASSET__CCdbq_wG__"